import MainLayout from '../layouts/main';
import ForgetPassword from './forget-password';

function ForgetPasswordPage() {
  return (
    <MainLayout loginRequired={false} studentRequired={false} title={FORGET_PASSWORD_PAGE_TITLE}>
      <ForgetPassword />
    </MainLayout>
  );
}

export const FORGET_PASSWORD_PAGE_TITLE = 'فراموشی رمز عبور';

export default ForgetPasswordPage;
